const SCRIPT_ELEMENT = document.currentScript;
document.addEventListener("alpine:init", () => {
  const PRICE_STANDARD = parseFloat(SCRIPT_ELEMENT.dataset.priceStandard);
  const PRICE_DELUXE = parseFloat(SCRIPT_ELEMENT.dataset.priceDeluxe);
  const PRICE_MAKING = parseFloat(SCRIPT_ELEMENT.dataset.priceMaking);
  const PRICE_ATTACHING = parseFloat(SCRIPT_ELEMENT.dataset.priceAttaching);
  const PRICE_FINISHING_MACHINE = parseFloat(
    SCRIPT_ELEMENT.dataset.priceFinishingMachine
  );
  const PRICE_FINISHING_HAND = parseFloat(
    SCRIPT_ELEMENT.dataset.priceFinishingHand
  );
  const MIN_QUILT_PRICE = parseFloat(
    SCRIPT_ELEMENT.dataset.minQuiltPrice
  );

  Alpine.data("aeoQuiltCalc", () => ({
    length: undefined,
    width: undefined,
    designType: "standard",
    finishingType: "machine",
    enableMaking: false,
    enableAttaching: false,
    enableFinishing: false,
    quiltArea() {
      return this.length * this.width;
    },
    designType: "standard",
    designSubtotal() {
      let price = 0;
      if (this.designType === "standard" || !this.designType) {
        price = this.quiltArea() * PRICE_STANDARD;
      } else if (this.designType === "deluxe") {
        price = this.quiltArea() * PRICE_DELUXE;
      }
      if (price > 0 && price < MIN_QUILT_PRICE) {
        return MIN_QUILT_PRICE;
      }
      if (isNaN(price)) {
        return 0;
      }
      return price;
    },
    designSubtotalFormatted() {
      if (isNaN(this.designSubtotal())) {
        return "$0.00";
      }
      return this.designSubtotal().toLocaleString("en-US", {
        style: "currency",
        currency: "USD",
      });
    },
    bindingLength() {
      if (
        !this.length ||
        !this.width ||
        isNaN(this.length) ||
        isNaN(this.width)
      ) {
        return 0;
      }
      return this.length * 2 + this.width * 2;
    },
    bindingLengthFormatted() {
      if (isNaN(this.bindingLength())) {
        return "0";
      }
      return Math.round(this.bindingLength()).toString();
    },
    bindingSubtotal() {
      return (
        this.makingSubtotal() +
        this.attachingSubtotal() +
        this.finishingSubtotal()
      );
    },
    bindingSubtotalFormatted() {
      if (isNaN(this.bindingSubtotal())) {
        return "$0.00";
      }
      return this.bindingSubtotal().toLocaleString("en-US", {
        style: "currency",
        currency: "USD",
      });
    },
    makingSubtotal() {
      if (!this.enableMaking) return 0;
      return this.bindingLength() * PRICE_MAKING;
    },
    makingSubtotalFormatted() {
      if (!this.enableMaking) return "$0.00";
      if (isNaN(this.makingSubtotal())) return "$0.00";
      return this.makingSubtotal().toLocaleString("en-US", {
        style: "currency",
        currency: "USD",
      });
    },
    attachingSubtotal() {
      if (!this.enableAttaching) return 0;
      return this.bindingLength() * PRICE_ATTACHING;
    },
    attachingSubtotalFormatted() {
      if (!this.enableAttaching) return "$0.00";
      if (isNaN(this.attachingSubtotal())) return "$0.00";
      return this.attachingSubtotal().toLocaleString("en-US", {
        style: "currency",
        currency: "USD",
      });
    },
    finishingSubtotal() {
      if (!this.enableFinishing) return 0;
      if (this.finishingType === "machine" || !this.finishingType) {
        return this.bindingLength() * PRICE_FINISHING_MACHINE;
      } else if (this.finishingType === "hand") {
        return this.bindingLength() * PRICE_FINISHING_HAND;
      }
      return 0;
    },
    finishingSubtotalFormatted() {
      if (!this.enableFinishing) return "$0.00";
      if (isNaN(this.finishingSubtotal())) return "$0.00";
      return this.finishingSubtotal().toLocaleString("en-US", {
        style: "currency",
        currency: "USD",
      });
    },
    total() {
      return (
        this.designSubtotal() +
        this.makingSubtotal() +
        this.attachingSubtotal() +
        this.finishingSubtotal()
      );
    },
    totalFormatted() {
      if (isNaN(this.total())) {
        return "$0.00";
      }
      return this.total().toLocaleString("en-US", {
        style: "currency",
        currency: "USD",
      });
    },
    reset() {
      this.length = 0;
      this.width = 0;
      this.designType = "standard";
      this.finishingType = "machine";
      this.enableMaking = true;
      this.enableAttaching = true;
      this.enableFinishing = true;
    },
  }));
});
